var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef } from 'react';
import toArray from '../_util/children/toArray';
import { createTaroPickerViewEvent } from '../_util/taroEvent';
import useTaroBaseEvents from '../_util/hooks/useTaroBaseEvents';
import useMergedState from '../_util/hooks/useMergedState';
import Wheel from './wheel';
const classPrefix = 'taro-picker-view';
const PickerView = (_a) => {
    var { value, indicatorStyle, indicatorClass, maskStyle, maskClass, title, children, onChange } = _a, rest = __rest(_a, ["value", "indicatorStyle", "indicatorClass", "maskStyle", "maskClass", "title", "children", "onChange"]);
    const props = useTaroBaseEvents(rest);
    const rootRef = useRef(null);
    const [mergedValue, setMergedValue] = useMergedState([], {
        value,
        onChange(current) {
            if (rootRef.current) {
                const taroEvent = createTaroPickerViewEvent(rootRef.current, current);
                onChange === null || onChange === void 0 ? void 0 : onChange(taroEvent);
            }
        }
    });
    const columns = toArray(children);
    return (_jsxs("div", Object.assign({ ref: rootRef, className: classPrefix }, props, { children: [!!title && _jsx("div", Object.assign({ className: `${classPrefix}_title` }, { children: title })), _jsxs("div", Object.assign({ className: `${classPrefix}_wrapper` }, { children: [columns.map((column, index) => (_jsx(Wheel, Object.assign({ value: mergedValue[index], onSelect: current => {
                            const next = [...mergedValue];
                            next[index] = current;
                            setMergedValue(next);
                        } }, { children: column.props.children }), index))), _jsxs("div", Object.assign({ className: `${classPrefix}-mask` }, { children: [_jsx("div", { className: `${classPrefix}-mask-top` }), _jsx("div", { className: `${classPrefix}-mask-middle` }), _jsx("div", { className: `${classPrefix}-mask-bottom` })] }))] }))] })));
};
export default PickerView;
